import { useState } from "react";
import { Button, Container, Modal, Row } from "react-bootstrap";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import FindCustomers from "../components/landing-page/FindCustomers";
import SuggestionBoxes from "../reusable-comps/SuggestionBoxes";
import useGetCities from "../api/useGetCities";
import useGetCategories from "../api/useGetCategories";
import useGetRegions from "../api/useGetRegion";
import getGeneralSearch from "../api/useGeneralSearch";
import getNarrowSearch from "../api/useNarrowSearch";
import useGetAllRatings from "../api/useGetAllRatings";
import RenderResults from "../components/landing-page/RenderResults";
import useGetGroupedBusinesses from "../api/useGetGroupedBusinesses";
import Skeleton from "../reusable-comps/Skeleton";
import {
  BagFill,
  BookmarkFill,
  BookmarkPlus,
  CardChecklist,
  CartCheck,
  GlobeEuropeAfrica,
  Pin,
  XLg,
} from "react-bootstrap-icons";
import FeaturedBusinesses from "../components/landing-page/FeaturedBusinesses";
import InforCards from "../components/landing-page/InfoCards";

const Home = ({ user }) => {
  const [search, setSearch] = useState("");
  const [like, setLike] = useState(false);
  const [searchState, setSearchState] = useState(false);
  const [city, setCity] = useState("");
  const [region, setRegion] = useState("");
  const [category, setCategory] = useState("");
  const [generalSearch, setGeneralSearch] = useState([]);
  const [narrowSearch, setNarrowSearch] = useState([]);
  const [show, setShow] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [grabEmail, setGrabEmail] = useState("");

  const token = user?.accessToken;
  const { cities } = useGetCities(token);
  const { categories } = useGetCategories(token);
  const { regions } = useGetRegions(token);
  const { grouped } = useGetGroupedBusinesses(token);
  const { allRatings } = useGetAllRatings(token);
  const [validated, setValidated] = useState(false);
  const [validatedNarrow, setValidatedNarrow] = useState(false);

  const handleGeneralSearch = (event) => {
    event.preventDefault();
    setSearchState(true);
    setValidated(true);
    setShowResult(true);
    return getGeneralSearch(setGeneralSearch, search, token);
  };

  const handleNarrowSearch = (event) => {
    event.preventDefault();
    setSearchState(true);
    setValidatedNarrow(true);
    setShowResult(true);
    return getNarrowSearch(setNarrowSearch, region, city, category, token);
  };

  const handleClose = () => setShow(false);

  const handleShow = (email) => {
    setGrabEmail(email);
    setShow(true);
  };

  const handleCloseMessage = () => setShowMessageModal(false);

  const handleShowMessage = (email) => {
    setGrabEmail(email);
    setShowMessageModal(true);
  };

  const cleansedData = (data, userEmail) => {
    const output = [];
    data.flat().forEach((item) => {
      if (userEmail === item?.ratingsOwner) {
        return output.push(item);
      }
    });
    return output;
  };

  const handleSaveSearch = () => {
    const data = { region, category, city };
    localStorage.setItem("last-search-parameters", JSON.stringify(data));
  };

  const handleRetrieveSearch = () => {
    try {
      const saved = JSON.parse(localStorage.getItem("last-search-parameters"));
      if (saved) {
        setRegion(saved.region || "");
        setCategory(saved.category || "");
        setCity(saved.city || "");
      }
    } catch {
      /* no saved data */
    }
  };

  return (
    <div
      className="px-0 custom-pry-color overflow-x-hidden"
      style={{ paddingTop: user ? "90px" : "60px" }}
    >
      {/* Unauthenticated nav */}
      {!user && window.location.pathname === "/" && (
        <Navbar className="w-100 py-1 mt-0 fixed-top main-nav">
          <Container className="d-flex justify-content-between">
            <Navbar.Brand
              as={Link}
              to="home"
              className="hstack gap-2 fw-bold brand-color"
            >
              <BagFill /> dugam
            </Navbar.Brand>
            <Navbar.Toggle />
            <Nav className="fw-bold hstack gap-3">
              <a
                href="/signup"
                className="text-decoration-none"
                style={{ color: "var(--text-primary)" }}
              >
                Signup
              </a>
              <a
                href="/login"
                className="text-decoration-none custom-pry btn text-light btn-sm fw-bold"
              >
                Login
              </a>
            </Nav>
          </Container>
        </Navbar>
      )}

      {/* Sticky saved-search pill — right margin center */}
      {user && (
        <div className="saved-search-pill">
          <button
            className="saved-search-btn"
            onClick={handleSaveSearch}
            title="Save current search"
          >
            <BookmarkPlus />
            <span className="pill-tooltip">Save search</span>
          </button>
          <button
            className="saved-search-btn"
            onClick={handleRetrieveSearch}
            title="Retrieve last search"
          >
            <BookmarkFill />
            <span className="pill-tooltip">Load saved</span>
          </button>
        </div>
      )}

      {/* Hero + Search */}
      <Row className="my-4 px-4 gap-3" style={{ height: "fit-content" }}>
        <div className="mx-auto hero-pad">
          <h1 className="h3 fw-bold mb-2">
            Dugam connects you with vendors and service providers in your area.
          </h1>
          <p className="custom-pry-text">
            Traders and business owners contact each other and establish new
            partnerships.
          </p>
        </div>
        <FindCustomers
          validated={validated}
          validatedNarrow={validatedNarrow}
          setSearch={setSearch}
          groupedData={grouped}
          search={search}
          regions={regions}
          cities={cities}
          categories={categories}
          setCategories={setCategory}
          setRegion={setRegion}
          setCity={setCity}
          category={category}
          city={city}
          region={region}
          handleGeneralSearch={handleGeneralSearch}
          handleNarrowSearch={handleNarrowSearch}
          handleResetGeneral={() => {
            setGeneralSearch([]);
            setSearch("");
            setSearchState(false);
          }}
          handleResetNarrow={() => {
            setNarrowSearch([]);
            setRegion("");
            setCity("");
            setCategory("");
            setSearchState(false);
          }}
        />
      </Row>

      {/* Platform Benefits */}
      <Row className="my-5 px-4 gap-2" style={{ height: "fit-content" }}>
        <h2 className="fw-bold h5 hstack p-sm-3 gap-2 mx-1">
          <CartCheck /> Platform Benefits
        </h2>
        <InforCards />
      </Row>

      {/* Popular Categories */}
      <Row className="my-5 px-4 gap-2" style={{ height: "fit-content" }}>
        <h2 className="fw-semibold h5 hstack p-sm-3 gap-2 mt-5 mx-1">
          <CardChecklist /> Popular categories
        </h2>
        <div className="d-flex flex-wrap gap-3 p-sm-3 text-center mt-3">
          {categories.length === 0 ? (
            <Skeleton children={""} />
          ) : (
            categories.map((el, i) => (
              <SuggestionBoxes key={i} title={el} user={user} />
            ))
          )}
        </div>
      </Row>

      {/* Featured Businesses */}
      <Row className="my-5 px-4 gap-2" style={{ height: "fit-content" }}>
        <h2 className="fw-bold h5 hstack p-sm-3 gap-2">
          <Pin /> Featured businesses
        </h2>
        <div className="px-4">
          <FeaturedBusinesses like={like} setLike={setLike} />
        </div>
      </Row>

      {/* Popular Regions */}
      <Row className="my-5 px-4 gap-2" style={{ height: "fit-content" }}>
        <h2 className="fw-bold h5 hstack gap-2 mx-1">
          <GlobeEuropeAfrica /> Popular regions
        </h2>
        <div className="d-flex flex-wrap px-4 gap-3 text-center mt-3">
          {regions.length === 0 ? (
            <Skeleton children={""} />
          ) : (
            regions.map((el, i) => (
              <SuggestionBoxes key={i} title={el} user={user} />
            ))
          )}
        </div>
      </Row>

      {/* Search Results Modal */}
      {showResult && (
        <Modal
          size="xl"
          show={showResult}
          onHide={() => setShowResult(!showResult)}
          backdrop="static"
          keyboard={false}
          fullscreen
        >
          <Modal.Header closeButton>
            <Modal.Title className="h6 fw-semibold">
              Search for businesses
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12 col-xxl-9">
              <FindCustomers
                validated={validated}
                validatedNarrow={validatedNarrow}
                setSearch={setSearch}
                groupedData={grouped}
                search={search}
                regions={regions}
                cities={cities}
                categories={categories}
                setCategories={setCategory}
                setRegion={setRegion}
                setCity={setCity}
                category={category}
                city={city}
                region={region}
                handleGeneralSearch={handleGeneralSearch}
                handleNarrowSearch={handleNarrowSearch}
                handleResetGeneral={() => {
                  setGeneralSearch([]);
                  setSearch("");
                  setSearchState(false);
                }}
                handleResetNarrow={() => {
                  setNarrowSearch([]);
                  setRegion("");
                  setCity("");
                  setCategory("");
                  setSearchState(false);
                }}
              />
            </div>
            <RenderResults
              city={city}
              category={category}
              region={region}
              search={search}
              searchState={searchState}
              allRatings={allRatings}
              cleansedData={cleansedData}
              narrowSearch={narrowSearch}
              generalSearch={generalSearch}
              user={user}
              show={show}
              handleClose={handleClose}
              handleShow={handleShow}
              showMessageModal={showMessageModal}
              grabEmail={grabEmail}
              handleCloseMessage={handleCloseMessage}
              handleShowMessage={handleShowMessage}
              handleReset={() => {
                setNarrowSearch([]);
                setRegion("");
                setCity("");
                setCategory("");
                setSearchState(false);
                setGeneralSearch([]);
                setSearch("");
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="sm"
              variant="transparent"
              className="btn-ghost"
              onClick={() => setShowResult(!showResult)}
            >
              <XLg />
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default Home;
